export var hasStatus = function (status, publisher) {
    if (Array.isArray(status)) {
        return status.includes(publisher.status);
    }
    return publisher.status === status;
};
